import React, { useEffect, useState } from 'react';
import ImageGallery from './ImageGallery';
import ProductDetails from './ProductDetails';
import Header from './Header';
import OrderModal from './OrderModal';
import ProductSelector from './ProductSelector';
import { toast, Toaster } from 'sonner';
import axios from 'axios';
import { XIcon } from 'lucide-react';
interface OrderItem {
  id: string;
  quantity: number;
  hasEngraving?: boolean;
  engravingMessage?: string;
}
const ProductPage = () => {
  // Product data array with 6 different art prints
  const products = [{
    id: 'box-small-1',
    name: 'Timeless elegance (Design 001)',
    price: '$45.00',
    originalPrice: '$50.00',
    discount: 'Save 10%',
    bulkPrice: '$40.00',
    engravingPrice: '$2.00',
    bulkMinimum: 10,
    description: 'This wellcrafted gift box showcases exquisite artistry through its detailed carvings and ornamental patterns. The box features delicate swirls, motifs and a finely engraved mandala-style design on the lid, highlighting the natural beauty of the wood grain. Its warm tones and intricate craftsmanship make it a versatile keepsake—perfect for gifting, decor, or storing precious items.',
    features: ['Includes 200gms of premium dry fruits', 'Comes with decorative tea light candles', 'Wooden gift box with intricate design', 'Perfect for gifting during festivals', 'Perfect size for jewelry, small keepsakes or gifts'],
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/3EdyT2NvxYRY2MQRuQmRYq/SmallSq1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/oGWXeQcC4wcPKAceJAcusv/SmallSq2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/bapMtJRgwVkXPMj7szge81/SmallSq2Custom.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ueUN3ter6w4uudNR8bWep3/SmallSq3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/bhGi1ukS9woyiKGYMiW9Lt/SmallDim.png'],
    additionalInfo: 'Please allow 5-6 days for product pickup/delivery. Bulk orders may require additional processing time.'
  }, {
    id: 'box-hex-design-1',
    name: 'Elegant Treasure (Design 002)',
    price: '$60.00',
    originalPrice: '$70.00',
    discount: 'Save 15%',
    bulkPrice: '$55.00',
    engravingPrice: '$2.00',
    bulkMinimum: 10,
    description: 'This wellcrafted hexagonal pinewood box features intricate carvings and a striking mandala-inspired lid design. Its natural tones and detailed craftsmanship make it both functional and ornamental. Perfect as a gift, keepsake holder, or decorative centerpiece, it embodies timeless elegance.',
    features: ['Includes 400gms of premium dry fruits', 'Comes with decorative tea light candles', 'Wooden gift box with intricate design', 'Perfect for gifting during festivals'],
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/obqNrFaihFiXJvdXHaT6Au/Hex1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/cXiJ1E7KWUhe82QxL2QfPR/Hex2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/t8YVeARKqXcLzHXM1HyDdP/Hex3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dEBcELGUuPAnXAisoYr2Lt/Hex1Dim.png'],
    additionalInfo: 'Please allow 5-6 days for product pickup/delivery. Bulk orders may require additional processing time.'
  }, {
    id: 'box-hex-design-2',
    name: 'Ornate Treasure (Design 003)',
    price: '$60.00',
    originalPrice: '$70.00',
    discount: 'Save 15%',
    bulkPrice: '$55.00',
    engravingPrice: '$2.00',
    bulkMinimum: 10,
    description: 'This exquisite hexagonal gift box showcases masterful craftsmanship with its intricate laser-cut mandala lid design and delicate swirl patterns on the sides. Made from premium wood with a beautiful natural finish, this versatile keepsake box is perfect for special occasions, festival gifting, or as a decorative accent in your home.',
    features: ['Includes 400gms of premium dry fruits', 'Handcrafted from premium wood', 'Comes with decorative tea light candles', 'Perfect for Diwali, weddings, and special occasions'],
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/czG9pzaUo9ifHxwhLVoNzx/Hex2_1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/5Y6Whs9X22hBEZmd72WveV/Hex2_2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/5AaCTHNQ64WEoiNLKxWYj5/Hex1Dim.png'],
    additionalInfo: 'Please allow 5-6 days for product pickup/delivery. Bulk orders may require additional processing time.'
  }, {
    id: 'box-hex-design-3',
    name: 'Moonlit pearls (Design 004)',
    price: '$60.00',
    originalPrice: '$70.00',
    discount: 'Save 15%',
    bulkPrice: '$55.00',
    engravingPrice: '$2.00',
    bulkMinimum: 10,
    description: 'This beautiful hexagonal gift box features elegant floral cutout patterns on the sides and a detailed mandala design on the lid. Perfect for festive occasions like Diwali, this handcrafted wooden box comes filled with premium dry fruits and includes decorative tea lights. The intricate laser-cut patterns create stunning light and shadow effects when illuminated.',
    features: ['Includes 400gms of premium dry fruits (cashews and almonds)', 'Comes with decorative tea light candles (bauble not included)', 'Laser-cut floral pattern sides with intricate detailing', 'Perfect for Diwali gifting and special celebrations'],
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/sucB2WNdiQbgpRN2vTLkKZ/Hex3_1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/aHwDgN2sNKJ8qSHwGqgAyq/Hex3_2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/bJb6cxzLnbxfAN6c9eYCF6/Hex3_3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/74ybNbmo18ZSFDkLKex23B/Hex1Dim.png'],
    additionalInfo: 'Please allow 5-6 days for product pickup/delivery. Bulk orders may require additional processing time.'
  }, {
    id: 'box-pent-design-1',
    name: 'Golden Whispers (Design 005)',
    price: '$60.00',
    originalPrice: '$70.00',
    discount: 'Save 15%',
    bulkPrice: '$55.00',
    engravingPrice: '$2.00',
    bulkMinimum: 10,
    description: 'This unique pentagon-shaped gift box features an elegant geometric design with intricate laser-cut patterns and a beautiful mandala centerpiece on the lid. Crafted from premium wood with a rich, natural finish, this versatile box makes a stunning presentation for special occasions, corporate gifting, or as a decorative accent piece for your home.',
    features: ['Includes 400g of premium dry fruits', 'Comes with decorative tea light candles', 'Perfect for weddings, anniversaries, and corporate gifts'],
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/nDpDL4tZtZFjCK6ewAg19c/Hex4_2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/pkqFNFnmSLX7wtN5jvt6KP/Hex4_1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dJuDkQvz83JPiiNSJsFqL2/Hex4_3.jpg'],
    additionalInfo: 'Please allow 5-6 days for product pickup/delivery. Bulk orders may require additional processing time.'
  }];
  const [orderItems, setOrderItems] = useState<OrderItem[]>([]);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [activeProductId, setActiveProductId] = useState(products[0].id);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Get the active product based on selected ID
  const activeProduct = products.find(p => p.id === activeProductId) || products[0];
  const handleAddToOrder = (quantity: number, hasEngraving: boolean = false, engravingMessage?: string) => {
    // Check if item already exists in order
    const existingItemIndex = orderItems.findIndex(item => item.id === activeProduct.id && item.hasEngraving === hasEngraving);
    if (existingItemIndex >= 0) {
      // Update quantity if item already in order
      const updatedItems = [...orderItems];
      updatedItems[existingItemIndex].quantity += quantity;
      setOrderItems(updatedItems);
    } else {
      // Add new item to order
      setOrderItems([...orderItems, {
        id: activeProduct.id,
        quantity,
        hasEngraving,
        engravingMessage: hasEngraving ? engravingMessage : undefined
      }]);
    }
    toast.success(`${quantity} item(s) added to your order`);
  };
  const handleRemoveFromOrder = (id: string, hasEngraving?: boolean) => {
    setOrderItems(orderItems.filter(item => !(item.id === id && item.hasEngraving === hasEngraving)));
    toast.success('Item removed from your order');
  };
  const handleUpdateQuantity = (id: string, quantity: number, hasEngraving?: boolean) => {
    setOrderItems(orderItems.map(item => item.id === id && item.hasEngraving === hasEngraving ? {
      ...item,
      quantity
    } : item));
  };
  const handleOpenOrderModal = () => {
    if (orderItems.length === 0) {
      toast.error('Your order is empty');
      return;
    }
    setIsOrderModalOpen(true);
  };
  const handleConfirmOrder = async (name: string, phone: string, engravingMessages: Record<string, string>) => {
    setIsSubmitting(true);
    try {
      // Format the order data for the API
      const orderData = {
        name,
        phone,
        order: orderItems.map(item => {
          const product = products.find(p => p.id === item.id);
          return {
            id: item.id,
            name: product ? product.name : 'Unknown Product',
            quantity: item.quantity,
            custommessage: item.hasEngraving ? item.engravingMessage || engravingMessages[item.id] || '' : ''
          };
        })
      };
      // Make the API call
      const response = await axios.post('https://all12.app.n8n.cloud/webhook/f0ac0d74-981b-4874-b9b9-f8f766c2a056', orderData, {
        headers: {
          Authorization: 'token',
          'Content-Type': 'application/json'
        }
      });
      console.log('Order API response:', response.data);
      // Close modal and show success message
      setIsOrderModalOpen(false);
      setOrderSuccess(true);
      setOrderItems([]);
      toast.success('Your order has been received! Our team will call you shortly.');
    } catch (error) {
      console.error('Error submitting order:', error);
      toast.error('There was a problem submitting your order. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  // Function to dismiss the order success notification
  const dismissOrderSuccess = () => {
    setOrderSuccess(false);
  };
  // Reset scroll position when changing products
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeProductId]);
  return <div className="min-h-screen bg-[#f8f7f4] flex flex-col" data-id="element-122">
      <Toaster position="top-center" duration={3000} data-id="element-123" />
      <Header orderCount={orderItems.reduce((total, item) => total + item.quantity, 0)} onOrderClick={handleOpenOrderModal} data-id="element-124" />
      <div className="flex-grow" data-id="element-125">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8" data-id="element-126">
          {/* Mobile Product Selector - Horizontal scrolling */}
          <div className="lg:hidden mb-6 bg-white p-4 rounded-lg shadow-sm" data-id="element-127">
            <ProductSelector products={products.map(p => ({
            id: p.id,
            name: p.name,
            thumbnail: p.images[0]
          }))} activeProductId={activeProductId} onSelectProduct={setActiveProductId} data-id="element-128" />
          </div>
          {/* Main Product Display with Selector on the left */}
          <div className="flex flex-col lg:flex-row gap-6" data-id="element-129">
            {/* Product Selector - Desktop left sidebar */}
            <div className="hidden lg:block w-full lg:w-1/6 order-2 lg:order-1 bg-white p-4 rounded-lg shadow-sm" data-id="element-130">
              <ProductSelector products={products.map(p => ({
              id: p.id,
              name: p.name,
              thumbnail: p.images[0]
            }))} activeProductId={activeProductId} onSelectProduct={setActiveProductId} data-id="element-131" />
            </div>
            {/* Main Content Area */}
            <div className="w-full lg:w-5/6 order-1 lg:order-2" data-id="element-132">
              <div className="flex flex-col lg:flex-row gap-8" data-id="element-133">
                {/* Image Gallery */}
                <div className="w-full lg:w-3/5" data-id="element-134">
                  <ImageGallery images={activeProduct.images} name={activeProduct.name} data-id="element-135" />
                </div>
                {/* Product Details */}
                <div className="w-full lg:w-2/5" data-id="element-136">
                  <ProductDetails product={activeProduct} onAddToOrder={handleAddToOrder} onOrderNow={() => {
                  handleAddToOrder(1);
                  handleOpenOrderModal();
                }} data-id="element-137" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OrderModal isOpen={isOrderModalOpen} onClose={() => setIsOrderModalOpen(false)} onConfirm={handleConfirmOrder} orderItems={orderItems} products={products} onRemoveItem={handleRemoveFromOrder} onUpdateQuantity={handleUpdateQuantity} data-id="element-138" />
      {orderSuccess && <div className="fixed bottom-4 right-4 bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded shadow-md max-w-md" data-id="element-139">
          <div className="flex justify-between items-start" data-id="element-140">
            <div data-id="element-141">
              <p className="font-medium" data-id="element-142">Order Received!</p>
              <p className="text-sm" data-id="element-143">
                Our team will call you shortly to confirm your order details.
              </p>
            </div>
            <button onClick={dismissOrderSuccess} className="text-green-700 hover:text-green-900 ml-2" aria-label="Close notification" data-id="element-144">
              <XIcon className="h-5 w-5" data-id="element-145" />
            </button>
          </div>
        </div>}
      {isSubmitting && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-146">
          <div className="bg-white p-4 rounded-md shadow-lg" data-id="element-147">
            <p className="text-gray-800" data-id="element-148">Processing your order...</p>
          </div>
        </div>}
    </div>;
};
export default ProductPage;